function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("defs", null);

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M283.97,0c-.1,0-1.59.02-2.83.02-.38,0-.74,0-1.02-.01V0Z",
  transform: "translate(-272)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M284.09.01h-.81c.4-.01.66-.01.67-.01h.06C284.04,0,284.07.01,284.09.01Z",
  transform: "translate(-272)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M285.61.01h-1.74c.02,0,.05-.01.08-.01h.06C284.02,0,284.75.01,285.61.01Z",
  transform: "translate(-272)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M287.85.01c-.28.01-.64.01-1.02.01-1.24,0-2.74-.02-2.84-.02h3.85Z",
  transform: "translate(-272)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M279.75,0c.5.02,2.48.01,3.53,0Zm5.86,0c1.03.01,2.24.02,2.62,0Z",
  transform: "translate(-272)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M295.156,12.19a.676.676,0,0,0-.605.72,1.335,1.335,0,0,1-1.221,1.45,1.224,1.224,0,0,1-1.27-.67,1.026,1.026,0,0,1,.049-.78,1.27,1.27,0,0,1,.566-.57,1.073,1.073,0,0,1,.189-.08.615.615,0,0,0,.2-.1,5.248,5.248,0,0,0-2.283-9.96,5.129,5.129,0,0,0-3.2,1.11,8.577,8.577,0,0,1,.824-2.3.7.7,0,0,0,.01-.67.663.663,0,0,0-.576-.34H280.1a.662.662,0,0,0-.575.34.694.694,0,0,0,.01.67,8.417,8.417,0,0,1,.8,2.24,5.233,5.233,0,1,0-5.409,8.91.62.62,0,0,0,.2.1,1.656,1.656,0,0,1,.178.07,1.256,1.256,0,0,1,.576.58.987.987,0,0,1,.059.78,1.231,1.231,0,0,1-1.28.67,1.362,1.362,0,0,1-.913-.47,1.339,1.339,0,0,1-.308-.98.662.662,0,0,0-.6-.72.681.681,0,0,0-.715.61,2.679,2.679,0,0,0,.625,1.95,2.623,2.623,0,0,0,1.817.94c.069,0,.149.01.228.01a2.7,2.7,0,0,0,1.231-.3,7.905,7.905,0,0,0,1.886,4.54,5.124,5.124,0,0,0,.933.84l-1.033,2.28a.7.7,0,0,0,.05.64.649.649,0,0,0,.556.3h11.1a.66.66,0,0,0,.605-.93L289.1,20.78a5.158,5.158,0,0,0,.933-.84,7.953,7.953,0,0,0,1.9-4.57,2.543,2.543,0,0,0,1.28.33c.069,0,.149-.01.228-.01a2.679,2.679,0,0,0,2.432-2.89A.674.674,0,0,0,295.156,12.19Zm-4.377-8.66a3.914,3.914,0,0,1,3.9,3.92,3.957,3.957,0,0,1-2.273,3.57,2.458,2.458,0,0,1-.288.11,3.539,3.539,0,0,1-.863.22,15.744,15.744,0,0,0-1.827-2.56,10.216,10.216,0,0,1-1.578-2.31,4.756,4.756,0,0,1-.308-1.19A3.851,3.851,0,0,1,290.779,3.53Zm-14.908,7.6a1.515,1.515,0,0,1-.268-.11,3.925,3.925,0,0,1,1.608-7.49,3.838,3.838,0,0,1,3.236,1.76,4.18,4.18,0,0,1-.308,1.2,9.759,9.759,0,0,1-1.578,2.3,15.679,15.679,0,0,0-1.826,2.56A3.536,3.536,0,0,1,275.871,11.13Zm3.563,11.54.705-1.56V21.1H287.8l.009.01.685,1.56Zm8.755-2.9c-.378.02-1.579.01-2.6,0h-2.313c-1.042.01-3.007.02-3.5,0-.477-.12-2.72-2.09-2.472-5.83a4.006,4.006,0,0,1,.427-1.54.6.6,0,0,0,.06-.19,13.8,13.8,0,0,1,1.8-2.58A10.754,10.754,0,0,0,281.36,7a5.8,5.8,0,0,0,.407-1.63.5.5,0,0,0,.02-.12V5.24a.969.969,0,0,0,.01-.17,8.925,8.925,0,0,0-.656-3.73H286.8a7.807,7.807,0,0,0-.228,5.71,11.076,11.076,0,0,0,1.806,2.66c1.062,1.3,2.154,2.64,2.263,4.23C290.888,17.68,288.645,19.65,288.189,19.77Z",
  transform: "translate(-272)"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

export default __webpack_public_path__ + "static/media/antiques.bde70c60.svg";
export { SvgComponent as ReactComponent };